import { render, staticRenderFns } from "./transcriptions-tab.vue?vue&type=template&id=5125f042&scoped=true"
import script from "./transcriptions-tab.vue?vue&type=script&lang=js"
export * from "./transcriptions-tab.vue?vue&type=script&lang=js"
import style0 from "./transcriptions-tab.vue?vue&type=style&index=0&id=5125f042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125f042",
  null
  
)

export default component.exports